export default "__VITE_ASSET__a085d777__"